import { loyaltyAccInfoConst } from '../constants/actionConstants';
import { objPendingErrorFalse } from '../constants/variableConstant';
import produce from 'immer';
const initState = {
  listMyGift: { obj: [] },
  listMyGiftRedeem: { obj: [] },
  myOwnGift: { used: { obj: [] }, unused: { obj: [] } },
  listMenu: { obj: [] },
  giftDetail: { obj: [] },
  listCity: { obj: [] },
  listTown: { obj: [] },
  listVillage: { obj: [] },
  profileMember: { obj: [] },
  miniGame: { obj: [] },
  reedemGift: { obj: [] },
  introduce: '',
  pending: false,
  error: false,
};

export default (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loyaltyAccInfoConst.GIFT_PASS_DATA_REDEEM:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_PASS_DATA_REDEEM_SUCCESS:
        draft.introduce = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_GETALL_BYMEMBERCODE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_GETALL_BYMEMBERCODE_SUCCESS:
        draft.listMyGift = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_CREAT_REDEEM_HISTORY:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_CREAT_REDEEM_HISTORY_SUCCESS:
        draft.listMyGiftRedeem = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_CATEGORY_GETALL_MENU:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_CATEGORY_GETALL_MENU_SUCCESS:
        draft.listMenu = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_GETALL_GETALLFORCATEGORY:
        draft.pending = true;
        break;
case loyaltyAccInfoConst.GIFT_GETALL_GETALLFORCATEGORY_SUCCESS:
        draft.getallforcategory = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_GETALL_GETALLWITHIMAGE_SUCCESS:
        draft.getallwithimage = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_VOUCHE_DETAIL:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_VOUCHE_DETAIL_SUCCESS:
        draft.giftDetail = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_CITYCODE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_CITYCODE_SUCCESS:
        draft.listCity = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_TOWNCODE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_TOWNCODE_SUCCESS:
        draft.listTown = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_VILLAGECODE:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_MODAL_REDEEM_GIFT_VILLAGECODE_SUCCESS:
        draft.listVillage = action.payload;
        draft.pending = false;
        break;

      case loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.LOYALTY_ACC_PROFILE_MEMBER_SUCCESS:
        draft.profileMember = action.payload;
        draft.pending = false;
        break;
      case loyaltyAccInfoConst.GIFT_CHECK_MINIGAME:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_CHECK_MINIGAME_SUCCESS:
        draft.miniGame = action.payload;
        draft.pending = false;
        break;
      case loyaltyAccInfoConst.GIFT_CREAT_REDEEM_TRANSACTION:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GIFT_CREAT_REDEEM_TRANSACTION_SUCCESS:
        draft.reedemGift = action.payload;
        draft.pending = false;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_USED:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_USED_SUCCESS:
        draft.myOwnGift.used = action.payload;
        draft.pending = false;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_UNUSED:
        draft.pending = true;
        break;
      case loyaltyAccInfoConst.GET_LOYALTY_OWNGIFT_UNUSED_SUCCESS:
        draft.myOwnGift.unused = action.payload;
        draft.pending = false;
        break;

      default:
        return state;
    }
  });
